/**
 * @fileoverview Utilidades de codificación de URLs para recursos multimedia.
 * @module mediaUrlUtils
 */

/**
 * Codifica de forma segura una URL de medios de WhatsApp/Cloudinary
 * reemplazando todos los `+` por `%2B` para evitar que servidores los
 * interpreten como espacios. Devuelve string vacío cuando la URL no es
 * un string válido (null/undefined/no-string), evitando crashes por
 * llamadas a `.replace()` sobre valores nulos.
 *
 * @param {*} url - URL potencialmente nula o no-string.
 * @returns {string} URL codificada o string vacío si no es procesable.
 */
export const encodeWhatsAppMediaUrl = (url) => {
  if (typeof url !== 'string' || !url) return '';
  return url.replace(/\+/g, '%2B');
};

export default encodeWhatsAppMediaUrl;
